module.exports = __webpack_public_path__ + "public/StoreIcon/profile.svg?4c3d15d5";